<template>
  <div class="finder-frame">
    <h4 v-if="label">{{ $t(label) }}</h4>
    <template v-for="(child, cindex) in children">
      <elem v-if="childIsApplicable(child)"
        v-on:click="childOpen(child, cindex)"
        :index="cindex"
        :icon="child.icon"
        :label="localeString(child.label)"
        :is-active="childIsActive(cindex)"
        :has-children="childHasChildren(child)"
        :tooltip="localeString(child.tooltip)"
        :tooltip-size="child.tooltipSize || 'medium'"
        :tooltip-orientation="tooltipOrientation"
      ></elem>
    </template>
  </div>
</template>

<script>
import FinderFrameElement from './FinderFrameElement.vue';
var __s__ = require('../Jaws3d/support-fns');

export default {
  components: {
    elem: FinderFrameElement
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    label: {
      type: String
    },
    index: {
      // type: Number,
      // default: 0
    },
    height: {
      type: Number
    },
    activeChild: {
      type: String,
      default: ''
    },
    isLast: {
      type: Boolean
    },
    children: {
      type: Object
    },
    targetTooth: {
      type: Number
    }
  },
  computed: {
    hasChildren() {
      Object.keys(this.children).length > 0;
    },
    tooltipOrientation() {
      return this.index == 2 ? 'left' : 'right';
    }
  },
  methods: {
    /*
    updateScroll(evt) {
      // getBoundingClientRect
      if (this.isLast) {
        var inner  = this.$el.getBoundingClientRect().left + this.$el.offsetWidth,
            box    = this.$el.parentNode.parentNode.getBoundingClientRect().left + this.$el.parentNode.parentNode.offsetWidth,
            margin = parseInt(this.$el.parentNode.style['margin-left']),
            delta  = inner - box;

        // console.log(this.label, 'inner:', inner, 'box:', box, 'margin:', margin, 'delta:', delta);

        if (delta > 0) {
          this.$el.parentNode.style['margin-left'] = (box - inner) + 'px';
        } else {
          this.$el.parentNode.style['margin-left'] = 0;
        }
      }
    },
    */
    childIsActive(index) {
      return (!this.hasChildren || !this.isLast) && this.activeChild == index;
    },
    childIsApplicable(child) {
      if (Array.isArray(child.appliesTo) && child.appliesTo.length === 2 && this.targetTooth) {
        return __s__.isToothNumberInRange(this.targetTooth, child.appliesTo[0], child.appliesTo[1]);
      }
      return true
    },
    childHasChildren(child) {
      return typeof child.children == 'object' && Object.keys(child.children).length > 0;
    },
    childOpen(child, index) {
      if (typeof child.onclick == 'function') {
        child.onclick(this);
        return;
      }

      // this.activeChild = index;

      this.$emit('click', child, this.index, index);
    },
    localeString(strObj) {
      return this.$root.getLabelText(strObj);
    }
  }
};
</script>
